'use client'

// The modular synth rack beside the piano, standing in the world.
//
// rack.glb: a case tilted back on an upturned fruit crate, against the
// same brick wall as the piano and facing the way its keyboard does, with
// six modules named the way world/Tunes.js names them (module_seq,
// module_vco, module_vcf, module_env, module_clock, module_vca), each its
// own node with its knobs, and rack_screen on the sequencer. Laid out in
// Blender at world coordinates like the piano, so it renders at IDENTITY;
// moving it means moving it in Blender, and the 'rack' POI in sceneConfig
// is where he stands, in front of it. The sim spawns the entity from that
// POI and only while rackEnabled, so nothing draws when the rack is off,
// same as before.

import { useStoreWithEqualityFn } from 'zustand/traditional'
import useGameStore from '../../../stores/gameStore'
import { useModel } from '../hooks/useModel'
import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'

const MODEL = '/models/rack.glb'

export function Rack() {
  const on = useStoreWithEqualityFn(
    useGameStore,
    (s) => s.entityStates.some((e) => e.id === 'activity_rack'),
  )
  const { scene } = useModel(MODEL)
  useSceneNodeMaterials(scene, { roughness: 0.85 })
  if (!on) return null
  return <primitive object={scene} />
}

export default Rack
